module.exports = __webpack_public_path__ + "static/media/options.d890a694.png";